import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

function LegalHeader({ title }: { title: string }) {
  return (
    <header className="sticky top-0 z-30 flex items-center gap-2 border-b border-slate-800 bg-slate-950/90 px-3 py-3 backdrop-blur">
      <Link
        to="/"
        className="flex h-10 w-10 items-center justify-center rounded-lg text-slate-300 active:bg-slate-800"
        aria-label="戻る"
      >
        <ArrowLeft className="h-5 w-5" />
      </Link>
      <h1 className="text-base font-semibold">{title}</h1>
    </header>
  );
}

export function Terms() {
  return (
    <div>
      <LegalHeader title="利用規約" />
      <div className="px-4 py-4 max-w-xl mx-auto">
        <p className="text-xs text-slate-400 mb-4">本サービスの利用規約です。</p>
        <h2 className="text-base font-semibold mt-4 mb-2">1. サービス概要</h2>
        <p className="text-sm text-slate-300">
          本サービスは、AIを活用した縦型動画の生成を行う買い切り型のアプリケーションです。
        </p>
        <h2 className="text-base font-semibold mt-4 mb-2">2. ライセンス</h2>
        <p className="text-sm text-slate-300">
          購入されたライセンスは1アカウント最大3デバイスまで利用可能です。
        </p>
        <h2 className="text-base font-semibold mt-4 mb-2">3. 禁止事項</h2>
        <p className="text-sm text-slate-300">
          実在人物のなりすまし、違法コンテンツの生成、第三者の権利を侵害する行為を禁じます。
        </p>
        <h2 className="text-base font-semibold mt-4 mb-2">4. 免責</h2>
        <p className="text-sm text-slate-300">
          生成されたコンテンツの利用による一切の損害について、運営は責任を負いません。
        </p>
      </div>
    </div>
  );
}

export function Privacy() {
  return (
    <div>
      <LegalHeader title="プライバシーポリシー" />
      <div className="px-4 py-4 max-w-xl mx-auto">
        <p className="text-xs text-slate-400 mb-4">
          本サービスにおける個人情報およびデータの取り扱いについて。
        </p>
        <h2 className="text-base font-semibold mt-4 mb-2">取得する情報</h2>
        <p className="text-sm text-slate-300">
          メールアドレス、購入情報、デバイスフィンガープリント、使用量ログ。
        </p>
        <h2 className="text-base font-semibold mt-4 mb-2">APIキーの取り扱い</h2>
        <p className="text-sm text-slate-300">
          BYOK APIキーはブラウザ内で暗号化保存され、サーバーには保管されません。
          API呼び出し時のみプロキシ経由で該当プロバイダーに転送されます。
        </p>
        <h2 className="text-base font-semibold mt-4 mb-2">ログ保持期間</h2>
        <p className="text-sm text-slate-300">
          使用量ログは90日、エラーログは30日、課金関連は7年保持されます。
        </p>
      </div>
    </div>
  );
}
